export default __webpack_public_path__ + "static/media/img_two.b2963385.png";